import 'katex/dist/katex.min.css'
import MarkdownPage from "./MarkdownPage";

type ManageHelpProps = {} & React.HTMLAttributes<HTMLDivElement>;

export default function ManageHelpPage({ children, ...props }: ManageHelpProps) {
  return (
    <MarkdownPage group={"public"} message={"help"} isEditable={true}></MarkdownPage>
  )
}
